<template>
  <el-button v-loading="submitIng" type="primary" size="small" @click="toHandle">
    <slot></slot>
  </el-button>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      submitIng: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {},
  methods: {
    toHandle() {
      const _this = this;
      _this.$confirm('是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.submitIng = false;
        _this.$api.productExport()
            .then(res => {
              _this.submitIng = false;
              _this.$message.success('操作成功');
              window.location.href = res.url;
            })
            .catch(err => {
              _this.submitIng = false;
              _this.$message.error(err.msg);
            })
      }).catch(() => {
      });
    }
  },
};
</script>